import api from '../api';
import { saveAs } from '../../utils/saveFile';
import {
  ThirdParty,
  ThirdPartyBulkImportResult,
  ThirdPartyCreate,
  ThirdPartyUpdate,
} from '../../types/compliance';

// NOTE: the shared axios instance (`services/api.ts`) is configured with
// baseURL = config.API_URL, which already includes the `/api/v1` prefix.
// Paths here are relative to that prefix.
const BASE = '/compliance/third-parties';

export const thirdPartiesService = {
  async list(search?: string): Promise<ThirdParty[]> {
    const params = search ? { search } : undefined;
    const { data } = await api.get<ThirdParty[]>(BASE, { params });
    return data;
  },

  async get(id: string): Promise<ThirdParty> {
    const { data } = await api.get<ThirdParty>(`${BASE}/${id}`);
    return data;
  },

  async create(body: ThirdPartyCreate): Promise<ThirdParty> {
    const { data } = await api.post<ThirdParty>(BASE, body);
    return data;
  },

  async update(id: string, body: ThirdPartyUpdate): Promise<ThirdParty> {
    const { data } = await api.patch<ThirdParty>(`${BASE}/${id}`, body);
    return data;
  },

  async remove(id: string): Promise<void> {
    await api.delete(`${BASE}/${id}`);
  },

  async downloadImportTemplate(): Promise<void> {
    await saveAs('third-parties-template.csv', async () => {
      const response = await api.get(`${BASE}/import-template`, {
        responseType: 'blob',
      });
      return new Blob([response.data], { type: 'text/csv' });
    });
  },

  async bulkImport(file: File): Promise<ThirdPartyBulkImportResult> {
    const fd = new FormData();
    fd.append('file', file);
    const { data } = await api.post<ThirdPartyBulkImportResult>(
      `${BASE}/bulk-import`,
      fd,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return data;
  },
};

export default thirdPartiesService;
